import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkz011aRequest, Sgkz011aResponse, SGKZ011AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSgkz011aService {

  /** ユーザー検索結果のSubject */
  private _userSearchResult$ = new Subject<Sgkz011aResponse>();

  /**
  * ユーザー検索結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSgkz011aService
  */
  get valueChanges() {
    return this._userSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKZ011AService} SGKZ011AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSgkz011aService
   */
  constructor(
    private sGKZ011AService: SGKZ011AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * ユーザ情報取得API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkz011aResponse>}
   * @memberof UsedSgkb122dSgkz011aService
   */
  searchContractor(value: Sgkz011aRequest): Observable<Sgkz011aResponse> {
    // 検索条件を保存
    return this.sGKZ011AService.kz10RSGKZ011APost(<Sgkz011aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._userSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKZ011A);
          return throwError(err.message);
        })
      );
  }
}
